import { render, staticRenderFns } from "./mocApproval.vue?vue&type=template&id=db8668f2"
import script from "./mocApproval.vue?vue&type=script&lang=js"
export * from "./mocApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db8668f2')) {
      api.createRecord('db8668f2', component.options)
    } else {
      api.reload('db8668f2', component.options)
    }
    module.hot.accept("./mocApproval.vue?vue&type=template&id=db8668f2", function () {
      api.rerender('db8668f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/mocApproval.vue"
export default component.exports